"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

exports.__esModule = true;
exports["default"] = void 0;

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.array.map");

var _format = _interopRequireDefault(require("date-fns/format"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _CalendarCell = _interopRequireDefault(require("./CalendarCell"));

var _propValidators = require("../utils/propValidators");

var _isDateInSet = _interopRequireWildcard(require("./utils/isDateInSet"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var CalendarRow = function CalendarRow(_ref) {
  var dates = _ref.dates,
      mode = _ref.mode,
      onSelect = _ref.onSelect,
      value = _ref.value,
      unavailable = _ref.unavailable,
      due = _ref.due,
      late = _ref.late;

  var row = /*#__PURE__*/_react["default"].createElement("tr", {
    role: "row"
  }, dates.map(function (date, index) {
    var decorators = {
      disabled: !date,
      due: mode === 'month' ? (0, _isDateInSet["default"])(date, due) : false,
      late: mode === 'month' ? (0, _isDateInSet["default"])(date, late) : false,
      selected: (0, _isDateInSet["default"])(date, value, mode === 'month' ? _isDateInSet.dateComparator : _isDateInSet.monthComparator),
      unavailable: mode === 'month' ? (0, _isDateInSet["default"])(date, unavailable) : false
    };
    return /*#__PURE__*/_react["default"].createElement(_CalendarCell["default"], _extends({
      date: date,
      key: date ? (0, _format["default"])(date, 'x') : index // fine to use index as key for blank cells
      ,
      mode: mode,
      onSelect: onSelect
    }, decorators));
  }));

  if (mode === 'month') {
    return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, row, /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("th", {
      "aria-hidden": "true",
      className: "grv-calendar__table-header-divider",
      colSpan: 7
    })));
  }

  return row;
};

var propTypes = {
  dates: _propTypes["default"].arrayOf(_propValidators.dateType).isRequired,
  due: _propValidators.dateSetType,
  late: _propValidators.dateSetType,
  mode: _propTypes["default"].oneOf(['month', 'year']).isRequired,
  onSelect: _propTypes["default"].func.isRequired,
  unavailable: _propValidators.dateSetType,
  value: _propTypes["default"].oneOfType([_propValidators.dateType, _propTypes["default"].arrayOf(_propValidators.dateType)])
};
CalendarRow.propTypes = propTypes;
var _default = CalendarRow;
exports["default"] = _default;